import * as React from 'react';
//import Select from 'react-select';
import {Client} from '../../_models/Client'
//import {customSelectStyles} from './selectStyles.js'
import * as controller from './controller'
import { withLocalize, Translate } from "react-localize-redux";

class ClientPage extends React.Component<any, any> {

  handleClientChange: any
  handleSelectChange: any
  updateClient:any
  picture: any

  constructor(props: any) {
    super(props);
    this.state = {
      client: new Client(),
      picture: "",
      updating: false
    }
    this.updateClient = controller.updateClient.bind(this)
    this.handleClientChange = controller.handleClientChange.bind(this)
  }



  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadClient(this.props.match.params.id)
    }

  }

  componentWillReceiveProps(nextProps: any) {
    if(nextProps.match.params.id
      && !isNaN(nextProps.match.params.id)
      && this.state.client.id != nextProps.match.params.id) {
      this.loadClient(nextProps.match.params.id)
    } else {
      this.setState({client: new Client()})
    }

  }

  selectFile(input: any) {
    let file = this.picture.files[0]
     var reader = new FileReader();
     let client = this.state.client
     client.updated = false
     reader.onload = (e: any) => {
       if(e.target) {
         this.setState({picture: e.target.result, client})

       }
     }
     reader.readAsDataURL(file);
  }


  loadClient(id:any) {
    fetch('clients/get', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let client = new Client(data.client)
        this.setState({client})
    }).catch(err => {
      alert(err.message);
    })
  }


  public render() {
    let client = this.state.client
    let url = this.state.picture.length? this.state.picture : process.env.REACT_APP_AWS+"/clients/"+client.id+"/pictures/"+client.picture
    return (
      <div id="edit-account-root">
          <i onClick={() => {this.props.history.goBack()}} className="fas fa-times"></i>
          <form className="data">
            {((client.id && client.picture.length) || (this.state.picture.length))?
              (<div className="picture" style={{backgroundImage: "url("+url+")"}} onClick={() => {this.picture.click()}}></div>)
            : (<div className="picture" onClick={() => {this.picture.click()}}></div>)}
            <input className="third" onChange={this.handleClientChange} defaultValue={client.name} name="name" placeholder={this.props.translate("name").toString()} />
            <input className="third" onChange={this.handleClientChange} defaultValue={client.phone} name="phone" placeholder={this.props.translate("phone").toString()} />
            <input className="third" onChange={this.handleClientChange} defaultValue={client.email} name="email" placeholder={this.props.translate("email").toString()} />
            <input className="third" onChange={this.handleClientChange} defaultValue={client.address} name="address" placeholder={this.props.translate("address").toString()} />
            <input className="third" onChange={this.handleClientChange} defaultValue={client.tax} name="tax" placeholder={this.props.translate("client.tax").toString()} />

            <input style={{display: "none"}} ref={el => this.picture = el} onChange={this.selectFile.bind(this, this.picture)} name="picture" type="file" />
            {(window.account.id == client.id || window.account.type == "admin") && <div><button className={"update "+((client.id && client.updated)? "updated" : "")} onClick={this.updateClient} disabled={client.updated || this.state.updating}>
              {this.state.updating? this.props.translate("updating").toString() :
                client.id? client.updated? this.props.translate("updated").toString() :
                this.props.translate("update").toString() :
                this.props.translate("save").toString()}
            </button>
            <button onClick={controller.resetPassword.bind(this, client.id)} className="primary-btn green" style={{width: "350px"}}><Translate id="resetPasswordAndSend" /></button></div>}
          </form>
        </div>
    )
  }
}

export default withLocalize(ClientPage)



// WEBPACK FOOTER //
// ./src/pages/client/Client.tsx